var IScroll=require("iscroll"),VIScroll={install:function(l,c){l.directive("iscroll",{inserted:function(l,o,r,e){var n,s=c;switch(o.value?[].toString.call(o.value):void 0){case"[object Function]":n=o.value;break;case"[object Object]":s=o.value}r.scroll=new IScroll(l,s),n&&n(r.scroll)},componentUpdated:function(l,c,o,r){o.scroll=r.scroll,o.scroll.refresh()},unbind:function(l,c,o,r){o.scroll=r.scroll,o.scroll.destroy(),o.scroll=null}})}};module.exports=VIScroll;


//////////////////
// WEBPACK FOOTER
// ./node_modules/viscroll/dist/viscroll.min.js
// module id = ziX5
// module chunks = 0